import React from "react";

const TextAreaField = ({ label, errorMessage, ...rest }) => (
  <div className="field">
    <label className="label">{ label }</label>
    <div className="control">
      <textarea className="textarea" { ...rest }/>
    </div>
    { errorMessage && <p className="help is-danger">{ errorMessage }</p> }
  </div>
)

export default TextAreaField